export const gudstjenesteItems = [
    {
        id: 1,
        title: "GUDSTJENESTEN",
        path: "./Gudstjenesten",
        cName: "SupLink"
    },
    {
        id: 2,
        title: "KIRKELIGE HANDLINGER",
        path: "./KirkeligeHandlinger",
        cName: "SupLink"
    },
    {
        id: 3,
        title: "PRÆDIKENER",
        path: "./Praedikener",
        cName: "SupLink"
    }
]